import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingConfiguration } from '../../../classes/entities/TimeTrackingConfiguration/timeTrackingConfigurationTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';

export function useTimeTrackingConfigurationDeleteHandler(
  timeTrackingConfiguration: TimeTrackingConfiguration
): () => void {
  return useEntityDeleteHandler(
    EntityName.TimeTrackingConfiguration,
    timeTrackingConfiguration,
    (activity) => activity.id // TODO: better name (add a name to the entity first)
  );
}
